import { useEffect, useRef } from "react";
import { motion } from "framer-motion";
import { X, ChevronLeft, ChevronRight, Eye } from "lucide-react";
import { http, fileUrl, fmtViews } from "../lib/api";

export const Lightbox = ({ items, index, onClose, onIndex }) => {
  const item = items[index];
  const counted = useRef(new Set());

  useEffect(() => {
    if (!item || counted.current.has(item.id)) return;
    counted.current.add(item.id);
    http.post(`/media/${item.id}/view`).catch(() => {});
  }, [item]);

  useEffect(() => {
    const onKey = (e) => {
      if (e.key === "Escape") onClose();
      if (e.key === "ArrowRight") onIndex((index + 1) % items.length);
      if (e.key === "ArrowLeft") onIndex((index - 1 + items.length) % items.length);
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [index, items.length, onClose, onIndex]);

  if (!item) return null;
  return (
    <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} className="fixed inset-0 z-[90] flex flex-col bg-black/95 backdrop-blur-xl" data-testid="photo-lightbox">
      <div className="flex items-center justify-between px-5 py-4 sm:px-10">
        <div className="min-w-0">
          <p className="font-serif-d truncate text-lg text-white sm:text-2xl">{item.title}</p>
          <p className="font-mono-d flex items-center gap-2 text-xs text-slate-400"><Eye size={12} /> {fmtViews(item.views + 1)} · {index + 1}/{items.length}</p>
        </div>
        <button onClick={onClose} className="p-2 text-white hover:text-rose-400" data-testid="lightbox-close-button" aria-label="Fechar"><X /></button>
      </div>
      <div className="relative flex flex-1 items-center justify-center px-4 pb-6">
        <motion.img key={item.id} initial={{ opacity: 0, scale: 0.98 }} animate={{ opacity: 1, scale: 1 }} transition={{ duration: 0.4 }} src={fileUrl(item.id)} alt={item.title} className="max-h-[78vh] max-w-full object-contain" />
        {items.length > 1 && (
          <>
            <button onClick={() => onIndex((index - 1 + items.length) % items.length)} className="absolute left-2 top-1/2 -translate-y-1/2 bg-black/60 p-3 text-white hover:bg-rose-600 sm:left-8" data-testid="lightbox-prev-button" aria-label="Anterior"><ChevronLeft /></button>
            <button onClick={() => onIndex((index + 1) % items.length)} className="absolute right-2 top-1/2 -translate-y-1/2 bg-black/60 p-3 text-white hover:bg-rose-600 sm:right-8" data-testid="lightbox-next-button" aria-label="Próxima"><ChevronRight /></button>
          </>
        )}
      </div>
    </motion.div>
  );
};
